<template>
  <v-list nav dense>
    <v-img
      :src="
        settings && settings.logo_url
          ? settings.logo_url
          : require('./assets/' +
              $LogoFolder +
              $t('$assets.fullLogoSmallWhite'))
      "
      contain
      width="144"
      class="my-4 ms-8 d-none d-lg-flex"
    />
    <div class="my-1 d-flex d-lg-none" />
    <v-list-item
      v-if="settingMode"
      color="sidebarActive"
      :key="$t('SettingNav.backHome')"
      @click.stop="$emit('backToHome')"
      link
    >
      <v-list-item-action class="ms-5 me-2">
        <v-icon>fa-home</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title class="my-n3">
          {{ $t("SettingNav.backHome") }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <template v-for="item in items">
      <v-list-group
        color="sidebarActive"
        v-if="item.subitems"
        :key="item.title"
        v-model="item.model"
        class="mb-1"
      >
        <template v-slot:activator>
          <v-list-item-action class="ms-5 me-2">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content class="me-n16">
            <v-list-item-title class="me-n16 my-n3">
              <v-badge
                :color="item.badge > 0 ? 'accent' : 'transparent'"
                :label="item.badge > 999 ? '999+' : '' + item.badge"
                :content="
                  item.badge > 0 ? (item.badge > 999 ? '999+' : item.badge) : ''
                "
                offset-y="10"
                offset-x="0"
                class="my-5"
                >{{ item.title }}
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          color="sidebarActive"
          v-for="(child, i) in item.subitems"
          :key="i"
          v-model="child.model"
          :href="
            child.link.substr(0, 1) == '/' ? '/#' + child.link : child.link
          "
          link
          @click.stop="$store.commit('navName', child.title)"
        >
          <v-list-item-action v-if="child.icon">
            <v-icon>
              {{ child.icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="ms-15 my-n3">
              <v-badge
                :color="child.badge > 0 ? 'accent' : 'transparent'"
                :label="child.badge > 999 ? '999+' : '' + child.badge"
                :content="
                  child.badge > 0
                    ? child.badge > 999
                      ? '999+'
                      : child.badge
                    : ''
                "
                offset-y="10"
                offset-x="0"
                class="my-5"
                >{{ child.title }}
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item
        color="sidebarActive"
        v-else
        :key="item.title"
        v-model="item.model"
        :href="'/#' + item.link"
        link
        @click.stop="$store.commit('navName', item.title)"
      >
        <v-list-item-action class="ms-5 me-2">
          <v-icon>
            {{ item.icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="my-n3">
            <v-badge
              :color="item.badge > 0 ? 'accent' : 'transparent'"
              :label="item.badge > 999 ? '999+' : '' + item.badge"
              :content="
                item.badge > 0 ? (item.badge > 999 ? '999+' : item.badge) : ''
              "
              offset-y="10"
              offset-x="0"
              class="my-5"
              >{{ item.title }}
            </v-badge>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <!-- 报表中心 -->
    <v-list-group
      color="sidebarActive"
      v-if="
        !settingMode &&
        ((this.settings && this.settings.intelligent_report == 1) ||
          $permission.permissionAllow('ReportDownloads', 'index'))
      "
      v-model="reportCenterModel"
      class="mb-1"
    >
      <template v-slot:activator>
        <v-list-item-action class="ms-5 me-2">
          <v-icon>fa-table</v-icon>
        </v-list-item-action>
        <v-list-item-content class="me-n16">
          <v-list-item-title class="me-n16 my-n3">
            {{ $t("Nav.reportCenter") }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <v-list-item
        v-if="this.settings && this.settings.intelligent_report == 1"
        color="sidebarActive"
        v-model="intelligenceReportsModel"
        target="intelligenceReports"
        :href="intelligenceReportsUrl"
        link
      >
        <v-list-item-content>
          <v-list-item-title class="ms-15 my-n3">
            {{ $t("Nav.intelligenceReports") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$permission.permissionAllow('ReportDownloads', 'index')"
        color="sidebarActive"
        v-model="reportDownloadsModel"
        target="reportDownloads"
        href="/#/report-downloads"
        link
        @click.stop="$store.commit('navName', $t('Nav.reportDownloads'))"
      >
        <v-list-item-content>
          <v-list-item-title class="ms-15 my-n3">
            {{ $t("Nav.reportDownloads") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<style scoped>
.v-icon.v-icon {
  font-size: 12px;
  width: 20px;
  text-align: center;
}
</style>

<script>
import { mapState } from "vuex";
import consts from "@/consts";
import i18n from "@/i18n";
import AccountUsers from "@/api/account_users";

// var homeNav = {
//   title: i18n.t("Nav.home"),
//   icon: "fa-home",
//   link: "/home",
//   model: true,
// };

export default {
  name: "Nav",

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["allow", "settings", "accountUser", "todos"]),
  },

  props: {
    settingMode: Boolean,
    login: Object,
    locale: String,
  },

  data: () => ({
    items: [],
    reportCenterModel: false,
    reportDownloadsModel: false,
    intelligenceReportsModel: false,
    intelligenceReportsUrl: "",
  }),

  watch: {
    $route() {
      this.items = this.makeItems();
      AccountUsers.my(true); // 每次路由变化都刷新权限和设置
      //判断当前url是否为报表中心的链接
      if (this.$route.path.startsWith("/report-downloads")) {
        this.reportDownloadsModel = true;
      }
      if (this.reportDownloadsModel || this.intelligenceReportsModel) {
        this.reportCenterModel = true;
      }
      //用于判断有权限访问小程序开发设置页面
      if (
        this.$route.path.startsWith("/settings/mini-develop-program") &&
        this.accountUser.type != 1
      ) {
        this.$router.replace("/404page");
      }
    },
    intelligenceReportsUrl: {
      immediate: true,
      handler() {
        if (!this.intelligenceReportsUrl.length) {
          this.intelligenceReportsUrl =
            this.$ReportURL +
            localStorage.getItem("accessToken") +
            "/" +
            encodeURIComponent("/material-sales");
        }
      },
    },
    settingMode: {
      immediate: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    locale: {
      immediate: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    allow: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    settings: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    todos: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
  },

  methods: {
    makeItems() {
      var nav = [];
      // nav.push(
      //   Object.assign({}, homeNav, {
      //     model:
      //       this.$route.path == homeNav.link ||
      //       this.$route.path.startsWith(homeNav.link + "/"),
      //   })
      // );
      var navItems = this.settingMode ? this.settingNavs() : this.navs();
      if (this.allow) {
        navItems.forEach((item) => {
          if (item.subitems) {
            var allowedSubitems = [];
            var itemModel = false;
            var itemBadge = 0;
            item.subitems.forEach((subitem) => {
              let controller = this.allow[subitem.controller];
              if (!subitem.controller) {
                subitem.model =
                  this.$route.path == subitem.link ||
                  this.$route.path.startsWith(subitem.link + "/");
                itemModel = itemModel || subitem.model;
                itemBadge += subitem.badge ? subitem.badge : 0;
                allowedSubitems.push(subitem);
              } else if (controller) {
                if (
                  controller.find((action) => subitem.action == action) &&
                  (!subitem.show || subitem.show())
                ) {
                  subitem.model =
                    this.$route.path == subitem.link ||
                    this.$route.path.startsWith(subitem.link + "/");
                  itemModel = itemModel || subitem.model;
                  itemBadge += subitem.badge ? parseInt(subitem.badge) : 0;
                  allowedSubitems.push(subitem);
                }
              }
            });
            if (allowedSubitems.length > 0) {
              item.subitems = allowedSubitems;
              item.model = itemModel;
              item.badge = itemBadge;
              nav.push(item);
            }
          } else {
            if (!item.controller) {
              item.model =
                this.$route.path == item.link ||
                this.$route.path.startsWith(item.link + "/");
              nav.push(item);
            } else {
              let controller = this.allow[item.controller];
              if (controller) {
                if (
                  controller.find((action) => item.action == action) &&
                  (!item.show || item.show())
                ) {
                  item.model =
                    this.$route.path == item.link ||
                    this.$route.path.startsWith(item.link + "/");
                  nav.push(item);
                }
              }
            }
          }
        });
      }
      return nav;
    },
    navs() {
      return [
        {
          title: i18n.t("Nav.orderManagement"),
          icon: "fa-shopping-cart",
          link: "/orders",
          subitems: [
            {
              title: i18n.t("Nav.orderNew"),
              link: "/order-new",
              controller: "Orders",
              action: "index",
              show: function () {
                return this.$permission.permissionAllow("Orders", "add");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.orders"),
              link: "/orders",
              controller: "Orders",
              action: "index",
              badge:
                this.todos && this.todos.order
                  ? this.todos.order.wait_confirm_count
                  : 0,
            },
            {
              title: i18n.t("Nav.ordersApprove"),
              link: "/orders-approve",
              controller: "Orders",
              action: "approval",
              badge:
                this.todos && this.todos.order
                  ? this.todos.order.wait_approve_count
                  : 0,
              show: function () {
                return (
                  this.settings &&
                  (!this.settings.process_order ||
                    (this.settings.process_order &&
                      (this.settings.process_order.indexOf(2) > -1 ||
                        this.settings.process_order.indexOf("2") > -1)))
                );
              }.bind(this),
            },
            {
              title: i18n.t("Nav.ordersStockOrdersOut"),
              link: "/order-stock-out",
              controller: "StockOuts",
              action: "index",
              badge:
                this.todos && this.todos.order
                  ? this.todos.order.wait_out_count
                  : 0,
              show: function () {
                return (
                  this.settings &&
                  (!this.settings.process_order ||
                    (this.settings.process_order &&
                      (this.settings.process_order.indexOf(3) > -1 ||
                        this.settings.process_order.indexOf("3") > -1)))
                );
              }.bind(this),
            },
            {
              title: i18n.t("Nav.distributions"),
              link: "/distributions",
              controller: "Distributions",
              action: "index",
              badge:
                this.todos && this.todos.order
                  ? this.todos.order.wait_distribute_count
                  : 0,
              show: function () {
                return (
                  this.settings &&
                  (!this.settings.process_order ||
                    (this.settings.process_order &&
                      (this.settings.process_order.indexOf(4) > -1 ||
                        this.settings.process_order.indexOf("4") > -1)))
                );
              }.bind(this),
            },
            {
              title: i18n.t("Nav.examines"),
              link: "/examines",
              controller: "Examines",
              action: "index",
              show: function () {
                return (
                  this.settings &&
                  (!this.settings.process_order ||
                    (this.settings.process_order &&
                      (this.settings.process_order.indexOf(5) > -1 ||
                        this.settings.process_order.indexOf("5") > -1)))
                );
              }.bind(this),
            },
            {
              title: i18n.t("Nav.ordersPricing"),
              link: "/orders-pricing",
              controller: "Orders",
              action: "getPricingMaterials",
              show: function () {
                return this.$permission.permissionAllow("Orders", "getPricingMaterials");
              }.bind(this),
            },
          ],
        },
        {
          title: i18n.t("Nav.returnOrderManagement"),
          icon: "fa-truck-loading",
          link: "/return-orders",
          subitems: [
            {
              title: i18n.t("Nav.returnOrderNew"),
              link: "/return-order-new",
              controller: "ReturnOrders",
              action: "index",
              show: function () {
                return this.$permission.permissionAllow("ReturnOrders", "add");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.returnOrderApply"),
              link: "/return-order-apply",
              controller: "ReturnOrders",
              action: "index",
              show: function () {
                return this.$permission.permissionAllow("ReturnOrders", "add");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.returnOrders"),
              link: "/return-orders",
              controller: "ReturnOrders",
              action: "index",
              badge:
                  this.todos && this.todos.return_order
                      ? this.todos.return_order.wait_confirm_count
                      : 0,
            },
            {
              title: i18n.t("Nav.returnOrdersApprove"),
              link: "/return-orders-approve",
              controller: "ReturnOrders",
              action: "index",
              show: function () {
                return (
                    this.$permission.permissionAllow(
                        "ReturnOrders",
                        "approval"
                    ) &&
                    this.settings &&
                    (!this.settings.process_return_order ||
                        (this.settings.process_return_order &&
                            (this.settings.process_return_order.indexOf(2) > -1 ||
                                this.settings.process_return_order.indexOf("2") > -1)))
                );
              }.bind(this),
              badge:
                  this.todos && this.todos.return_order
                      ? this.todos.return_order.wait_approve_count
                      : 0,
            },
            {
              title: i18n.t("Nav.returnBaskets"),
              link: "/return-baskets",
              controller: "ReturnBaskets",
              action: "index",
              show: function () {
                return this.$permission.permissionAllow("ReturnBaskets", "index");
              }.bind(this),
            },
            // {
            //   title: i18n.t("Nav.returnOrdersStockOrdersIn"),
            //   link: "/stocks-in-return-orders",
            //   controller: "StockIns",
            //   action: "index",
            //   badge:
            //     this.todos && this.todos.return_order
            //       ? this.todos.return_order.wait_in_count
            //       : 0,
            //   show: function () {
            //     return (
            //       this.settings &&
            //       (!this.settings.process_return_order ||
            //         (this.settings.process_return_order &&
            //           (this.settings.process_return_order.indexOf(3) > -1 ||
            //             this.settings.process_return_order.indexOf("3") > -1)))
            //     );
            //   }.bind(this),
            // },
          ],
        },
        {
          title: i18n.t("Nav.purchases"),
          icon: "fa-truck",
          link: "/purchases",
          subitems: [
            {
              title: i18n.t("Nav.stockout"),
              link: "/purchase/stockout",
              controller: "Purchases",
              action: "short",
            },
            {
              title: i18n.t("Nav.intelligentPurchase"),
              link: "/intelligent-purchase",
              controller: "Purchases",
              action: "getIntelligentPurchaseDetails",
            },
            {
              title: i18n.t("Nav.purchasePlans"),
              link: "/purchase-plans",
              controller: "PurchasePlans",
              action: "index",
            },
            {
              title: i18n.t("Nav.purchaseTasks"),
              link: "/purchase-tasks",
              controller: "PurchaseTasks",
              action: "index",
            },
            {
              title: i18n.t("Nav.purchasesList"),
              link: "/purchases",
              controller: "Purchases",
              action: "index",
            },
            {
              title: i18n.t("Nav.purchasesExamine"),
              link: "/purchases-examine",
              controller: "Purchases",
              action: "index",
              show: function () {
                return this.$permission.permissionAllow(
                  "Purchases",
                  "examineHistory"
                );
              }.bind(this),
            },
            {
              title: i18n.t("Nav.supplier"),
              link: "/supplier",
              controller: "Suppliers",
              action: "index",
            },
            {
              title: i18n.t("Nav.quotation"),
              link: "/quotations",
              controller: "Quotations",
              action: "index",
            },
            {
              title: i18n.t("Nav.economy"),
              link: "/economies",
              controller: "Economies",
              action: "index",
            },
            {
              title: i18n.t("Nav.supplierScore"),
              link: "/supplier-score",
              controller: "Suppliers",
              action: "supplierScore",
              show: function () {
                return this.$permission.permissionAllow(
                  "Suppliers",
                  "supplierScore"
                );
              }.bind(this),
            },
            {
              title: i18n.t("Nav.PurchaseInventory"),
              link: "/purchase-inventory",
              controller: "Purchases",
              action: "getInventoryReference",
              show: function () {
                return this.$permission.permissionAllow(
                  "Purchases",
                  "getInventoryReference"
                );
              }.bind(this),
            },
            {
              title: i18n.t("Nav.supplierSelfPurchase"),
              link: "/supplier-self-purchase",
              controller: "Suppliers",
              action: "index",
              show: function () {
                return (this.$permission.permissionAllow(
                    "Suppliers",
                    "index"
                  ) && (this.settings && this.settings.supplier_self_purchase)
                );
              }.bind(this),
            }
          ],
        },
        {
          title: i18n.t("Nav.returnPurchaseManagement"),
          icon: "fa-truck-loading",
          link: "/return-purchases",
          subitems: [
            {
              title: i18n.t("Nav.returnPurchaseNew"),
              link: "/return-purchase-new",
              controller: "ReturnPurchases",
              action: "add",
              show: function () {
                return this.$permission.permissionAllow("ReturnPurchases", "add");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.returnPurchases"),
              link: "/return-purchases",
              controller: "ReturnPurchases",
              action: "index",
              // badge:
              //     this.todos && this.todos.return_order
              //         ? this.todos.return_order.wait_confirm_count
              //         : 0,
            },
            {
              title: i18n.t("Nav.returnPurchaseApprove"),
              link: "/return-purchases-approve",
              controller: "ReturnPurchases",
              action: "approve",
              show: function () {
                return this.$permission.permissionAllow("ReturnOrders", "approval")
              }.bind(this),
            //   badge:
            //       this.todos && this.todos.return_order
            //           ? this.todos.return_order.wait_approve_count
            //           : 0,
            }
          ],
        },
        {
          title: i18n.t("Nav.stockManagement"),
          icon: "fa-calculator",
          link: "/stocks",
          subitems: [
            {
              title: i18n.t("Nav.currentStocks"),
              link: "/current-stocks",
              controller: "StockCurrents",
              action: "index",
            },
            {
              title: i18n.t("Nav.currentPosition"),
              link: "/current-position",
              controller: "PositionCurrents",
              action: "index",
              show: function () {
                return this.settings && this.settings.stock_position_setting;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.movePositionOrder"),
              link: "/move-position-order",
              controller: "PositionMoves",
              action: "index",
              show: function () {
                return this.settings && this.settings.stock_position_setting;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.stocks"),
              link: "/stocks",
              controller: "Stocks",
              action: "index",
            },
            {
              title: i18n.t("Nav.requisitions"),
              link: "/requisitions",
              controller: "Requisitions",
              action: "index",
            },
            {
              title: i18n.t("Nav.stockTakeOrders"),
              link: "/stock-take-orders",
              controller: "StockTakes",
              action: "index",
            },
            {
              title: i18n.t("Nav.stockOrdersIn"),
              link: "/stock-orders-in",
              controller: "StockIns",
              action: "index",
            },
            {
              title: i18n.t("Nav.putaway"),
              link: "/putaway",
              controller: "StockIns",
              action: "getWaitShelveOnList",
              show: function () {
                return this.settings && this.settings.stock_position_setting;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.stockOrdersOut"),
              link: "/stock-orders-out",
              controller: "StockOuts",
              action: "index",
            },
            {
              title: i18n.t("Nav.waveGenerate"),
              link: "/wave-generate",
              controller: "Waves",
              action: "add",
              show: function () {
                return this.settings && this.settings.stock_position_setting;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.waves"),
              link: "/waves",
              controller: "Waves",
              action: "index",
              show: function () {
                return this.settings && this.settings.stock_position_setting;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.waitOutMaterialAnalyses"),
              link: "/wait-out-material-analyses",
              controller: "StockOuts",
              action: "waitOutMaterialAnalyses",
            },
            {
              title: i18n.t("Nav.stockOrderAnalyze"),
              link: "/stock-order-analyze",
              controller: "StockOrderAnalyze",
              action: "index",
            },
            {
              title: i18n.t("Nav.stockBatch"),
              link: "/stock-details",
              controller: "StockDetails",
              action: "index",
            },
          ],
        },
        {
          title: i18n.t("Nav.productionManagement"),
          icon: "fa-cubes",
          subitems: [
            {
              title: i18n.t("Nav.autoSplitProduction"),
              link: "/auto-split-production",
              controller: "ProductionPlans",
              action: "autoSplitStockIns",
              show: function () {
                return this.settings && this.settings.production_module;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.productionPlans"),
              link: "/production-plans",
              controller: "ProductionPlans",
              action: "index",
              show: function () {
                return this.settings && this.settings.production_module;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.productionStockOUT"),
              link: "/production-stock-out",
              controller: "ProductionPlans",
              action: "outs",
              show: function () {
                return this.settings && this.settings.production_module;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.productionStockIN"),
              link: "/production-stock-in",
              controller: "ProductionPlans",
              action: "ins",
              show: function () {
                return this.settings && this.settings.production_module;
              }.bind(this),
            },
          ],
        },
        {
          title: i18n.t("Nav.materialManagement"),
          icon: "fa-cube",
          link: "/materials",
          subitems: [
            {
              title: i18n.t("Nav.materialCategories"),
              link: "/material-categories",
              controller: "MaterialCategories",
              action: "index",
            },
            {
              title: i18n.t("Nav.materialShowCategories"),
              link: "/material-show-categories",
              controller: "MaterialShowCategories",
              action: "add",
              show: function () {
                return (
                  this.settings &&
                  this.settings.miniprogram &&
                  (this.settings.miniprogram.template_id == "4" ||
                    this.settings.miniprogram.template_id == "3")
                );
              }.bind(this),
            },
            {
              title: i18n.t("Nav.materials"),
              link: "/materials",
              controller: "Materials",
              action: "index",
            },
            {
              title: i18n.t("Nav.units"),
              link: "/unit",
              controller: "Configs",
              action: "index",
            },
            {
              title: i18n.t("Nav.materialTemplates"),
              link: "/templates",
              controller: "Templates",
              action: "index",
            },
            {
              title: i18n.t("Nav.materialOrderRules"),
              link: "/material-order-rules",
              controller: "OrderRulers",
              action: "show",
            },
            {
              title: i18n.t("Nav.materialCampaign"),
              link: "/material-campaigns",
              controller: "MaterialCampaigns",
              action: "index",
            },
            {
              title: i18n.t("Nav.campaign"),
              link: "/campaign",
              controller: "Campaigns",
              action: "index",
              show: function () {
                return this.settings && this.settings.campaign_use_setting == 2;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.materialCoupons"),
              link: "/material-coupons",
              controller: "Coupons",
              action: "index",
            },
            {
              title: i18n.t("Nav.PreSell"),
              link: "/pre-sell",
              controller: "PresaleTemplates",
              action: "index",
              show: function () {
                return this.settings && this.settings.presale_enable == 1;
              }.bind(this),
            },
          ],
        },
        {
          title: i18n.t("Nav.dishManagement"),
          icon: "fa-kaaba",
          link: "/dishes",
          subitems: [
            {
              title: i18n.t("Nav.dishCategories"),
              link: "/dish-categories",
              controller: "FoodCategories",
              action: "index",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.dishes"),
              link: "/dishes",
              controller: "Foods",
              action: "index",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.recipeManagement"),
              link: "/recipes",
              controller: "FoodFormula",
              action: "index",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.dishTemplates"),
              link: "/dish-templates",
              controller: "FoodTemplates",
              action: "index",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.foodLogs"),
              link: "/dish-logs",
              controller: "Foods",
              action: "foodLogs",
            },
            // {
            //   title: i18n.t("Nav.menuPlans"),
            //   link: "/menuPlans",
            // controller: "MaterialCampaigns",
            // action: "index",
            // },
          ],
        },
        // {
        //   title: i18n.t("Nav.subAccountManagement"),
        //   icon: "fa-kaaba",
        //   link: "/dishes",
        //   subitems: [
        //     {
        //       title: i18n.t("Nav.subAccountConfig"),
        //       link: "/dish-sub-account-configs",
        //       controller: "FoodCategories",
        //       action: "index",
        //       show: function () {
        //         return this.settings && this.settings.shop_inventory_enable;
        //       }.bind(this),
        //     },
        //   ]
        // },
        {
          title: i18n.t("Nav.shopManagement", [consts.shopName()]),
          icon: "fa-store",
          link: "/shops",
          subitems: [
            {
              title: i18n.t("Nav.alliances", [consts.allianceName()]),
              link: "/alliances",
              controller: "AllianceBusinesses",
              action: "index",
            },
            {
              title: i18n.t("Nav.shops", [consts.shopName()]),
              link: "/shops",
              controller: "Shops",
              action: "index",
            },
            {
              title: i18n.t("Nav.districts"),
              link: "/districts",
              controller: "Districts",
              action: "index",
            },
            {
              title: i18n.t("Nav.registers"),
              link: "/registers",
              controller: "Registers",
              action: "index",
              badge:
                this.todos && this.todos.customer
                  ? this.todos.customer.wait_register_count
                  : 0,
            },
          ],
        },
        {
          title: i18n.t("Nav.customerMaintenance"),
          icon: "fa-users",
          link: "/qacenter",
          subitems: [
            {
              title: i18n.t("Nav.complaint"),
              link: "/qacenter",
              controller: "Qacenter",
              action: "index",
            },
            {
              title: i18n.t("Nav.announcement"),
              link: "/announcement",
              controller: "Announcements",
              action: "index",
            },
            {
              title: i18n.t("Nav.accountAds"),
              link: "/account-ads",
              controller: "AccountAds",
              action: "index",
            },
          ],
        },
        {
          title: i18n.t("Nav.shopPsi"),
          icon: "fa-calculator",
          link: "/shop-psi",
          show: function () {
            return this.settings && this.settings.shop_inventory_enable;
          }.bind(this),
          subitems: [
            {
              title: i18n.t("Nav.shopStockTakeOrders"),
              link: "/shop-stock-take-orders",
              controller: "Shops",
              action: "shopStockTakeOrders",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.shopStockOrdersIn"),
              link: "/shop-stock-orders-in",
              controller: "Shops",
              action: "shopStockOrdersIn",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.shopStockOrdersOut"),
              link: "/shop-stock-orders-out",
              controller: "Shops",
              action: "shopStockOrdersOut",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.shopStock"),
              link: "/shop-psi",
              controller: "Shops",
              action: "shopPsi",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.shopInOut"),
              link: "/shop-stock-order-analyze",
              controller: "Shops",
              action: "shopPsiDetail",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
          ],
        },
        {
          title: i18n.t("Nav.fundManagement"),
          icon: "fa-chart-bar",
          link: "/receipt",
          subitems: [
            {
              title: i18n.t("Nav.capital"),
              link: "/capital",
              controller: "Shops",
              action: "getShopBalanceHistories",
            },
            {
              title: i18n.t("Nav.capitalHistory"),
              link: "/account-history",
              controller: "Shops",
              action: "getShopBalanceHistories",
            },
            {
              title: i18n.t("Nav.receipt"),
              link: "/receipts",
              controller: "Receipt",
              action: "index",
            },
            {
              title: i18n.t("Nav.inanceReceipt"),
              link: "/finance-bills",
              controller: "FinanceBills",
              action: "index",
              show: function () {
                return (
                 (this.settings &&
                  this.settings.finance_bill_enable &&
                  this.settings.finance_bill_enable == "1") &&
                 (!this.$permission.permissionAllow('FinanceBills', 'indexForOrder') &&
                  !this.$permission.permissionAllow('FinanceBills', 'indexForReturn') &&
                  !this.$permission.permissionAllow('FinanceBills', 'indexForPurchase') &&
                  !this.$permission.permissionAllow('FinanceBills', 'indexForPurchaseReturn') &&
                  !this.$permission.permissionAllow('FinanceBills', 'indexForPurchaseReturnOrder'))
                );
              }.bind(this),
            },
            {
              title: i18n.t("Nav.paymentBatch"),
              link: "/payment-batch",
              controller: "Receipt",
              action: "batchReceiveAndPay",
            },
            {
              title: i18n.t("Nav.receiptHistory"),
              link: "/receipt-history",
              controller: "Receipt",
              action: "history",
            },
            {
              title: i18n.t("Nav.payment"),
              link: "/payment",
              controller: "Payment",
              action: "getPaySettings",
            },
            {
              title: i18n.t("Nav.receiptBillAnalyze"),
              link: "/receipt-bill-analyze",
              controller: "Receipt",
              action: "billAnalyze",
            },
          ],
        },
        {
          title: i18n.t("Nav.inanceReceipt"),
          icon: "fa-receipt",
          link: "/receipt",
          subitems: [
            {
              title: i18n.t("Nav.financeBillForOrder"),
              link: "/finance-bills-order",
              controller: "FinanceBills",
              action: "indexForOrder",
              show: function () {
                return (this.settings && this.settings.finance_bill_enable && this.settings.finance_bill_enable == "1");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.financeBillForReturn"),
              link: "/finance-bills-return",
              controller: "FinanceBills",
              action: "indexForReturn",
              show: function () {
                return (this.settings && this.settings.finance_bill_enable && this.settings.finance_bill_enable == "1");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.financeBillForPurchase"),
              link: "/finance-bills-purchase",
              controller: "FinanceBills",
              action: "indexForPurchase",
              show: function () {
                return (this.settings && this.settings.finance_bill_enable && this.settings.finance_bill_enable == "1");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.financeBillForPurchaseReturn"),
              link: "/finance-bills-purchaseReturn",
              controller: "FinanceBills",
              action: "indexForPurchaseReturn",
              show: function () {
                return (this.settings && this.settings.finance_bill_enable && this.settings.finance_bill_enable == "1");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.financeBillForReturnPurchase"),
              link: "/finance-bills-returnPurchase",
              controller: "FinanceBills",
              action: "indexForPurchaseReturnOrder",
              show: function () {
                return (this.settings && this.settings.finance_bill_enable && this.settings.finance_bill_enable == "1");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.financeBillForRequisition"),
              link: "/finance-bills-requisition",
              controller: "FinanceBills",
              action: "indexForRequisitionReceive",
              show: function () {
                return (this.settings && this.settings.finance_bill_enable && this.settings.finance_bill_enable == "1");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.financeBillForRequisitionPay"),
              link: "/finance-bills-requisitionPay",
              controller: "FinanceBills",
              action: "indexForRequisitionPay",
              show: function () {
                return (this.settings && this.settings.finance_bill_enable && this.settings.finance_bill_enable == "1");
              }.bind(this),
            },
          ],
        },
        {
          title: i18n.t("Nav.thirdPayment"),
          icon: "fa-credit-card",
          link: "/huifu",
          subitems: [
            {
              title: i18n.t("Nav.huifuAccount"),
              link: "/huifu",
              controller: "ThirdAccountInfo",
              action: "index",
            },
            {
              title: i18n.t("Nav.huifuPay"),
              link: "/huifu-pay",
              controller: "ThirdAccountInfo",
              action: "thirdPayRecords",
            },
            {
              title: i18n.t("Nav.huifuCash"),
              link: "/huifu-cash",
              controller: "ThirdAccountInfo",
              action: "thirdCashRecords",
            },
            {
              title: i18n.t("Nav.lakalaAccount"),
              link: "/lakala",
              controller: "ThirdAccountInfo",
              action: "indexForLkl",
              show: function () {
                return (this.settings && !this.settings.lkl_sub_account_enable);
              }.bind(this),
            },
            {
              title: i18n.t("Nav.lakalaPay"),
              link: "/lakala-pay",
              controller: "ThirdAccountInfo",
              action: "thirdPayRecordsForLkl",
              show: function () {
                return (this.settings && !this.settings.lkl_sub_account_enable);
              }.bind(this),
            },
            {
              title: i18n.t("Nav.lakalaCash"),
              link: "/lakala-cash",
              controller: "ThirdAccountInfo",
              action: "thirdCashRecordsForLkl",
              show: function () {
                return (this.settings && !this.settings.lkl_sub_account_enable);
              }.bind(this),
            },
          ],
        },
        // {
        //   title: i18n.t("Nav.reportCenter"),
        //   icon: "fa-table",
        //   link: "/report-downloads",
        //   subitems: [
        //     {
        //       title: i18n.t("Nav.intelligenceReports"),
        //       link:
        // this.$ReportURL +
        // localStorage.getItem("accessToken") +
        // "/" +
        // encodeURIComponent("/material-sales"),
        //     },
        //     {
        //       title: i18n.t("Nav.reportDownloads"),
        //       link: "/report-downloads",
        //       controller: "ReportDownloads",
        //       action: "index",
        //     },
        //   ],
        // },
      ];
    },
    settingNavs() {
      var settingNavs = [
        {
          title: i18n.t("SettingNav.settings"),
          icon: "fa-cogs",
          link: "/settings/bussiness-settings",
          subitems: [
            {
              title: i18n.t("SettingNav.organization"),
              link: "/settings/organizations",
              controller: "Organizations",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.roles"),
              link: "/settings/roles",
              controller: "Roles",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.accountUsers"),
              link: "/settings/account-users",
              controller: "AccountUsers",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.processSetting"),
              link: "/settings/process-settings",
              controller: "Settings",
              action: "processSetting",
            },
            {
              title: i18n.t("SettingNav.businessSetting"),
              link: "/settings/bussiness-settings",
              controller: "Settings",
              action: "businessSetting",
            },

            {
              // title: i18n.t("SettingNav.otherSetting"),
              // link: "/settings/other-settings",
              title: i18n.t("SettingNav.overSellSetting"),
              link: "/settings/over-sell-settings",
              controller: "AvailableStockMaterials",
              action: "index",
            },
            {
              // title: i18n.t("SettingNav.otherSetting"),
              // link: "/settings/other-settings",
              title: i18n.t("SettingNav.smsPushSetting"),
              link: "/settings/sms-push-setting",
              controller: "Settings",
              action: "pushSetting",
            },
            {
              title: i18n.t("SettingNav.miniProgramSetting"),
              link: "/settings/mini-program-settings",
              controller: "Settings",
              action: "miniprogramSetting",
            },
            // 小程序开发设置
            {
              title: i18n.t("SettingNav.miniDevelopProgram"),
              link: "/settings/mini-develop-program",
              controller: "Settings",
              action: "businessSetting",
              show: function () {
                return this.accountUser.type == 1;
              }.bind(this),
            },
            {
              title: i18n.t("SettingNav.thirdApiSetting"),
              link: "/settings/third-api-setting",
              controller: "Settings",
              action: "thirdApiSetting",
              show: function () {
                return this.accountUser.type == 1;
              }.bind(this),
            },
            {
              // title: i18n.t("SettingNav.otherSetting"),
              // link: "/settings/other-settings",
              title: i18n.t("SettingNav.logisticsSetting"),
              link: "/settings/logistics-setting",
              controller: "Logistics",
              action: "view",
            },
            {
              // title: i18n.t("SettingNav.otherSetting"),
              // link: "/settings/other-settings",
              title: i18n.t("SettingNav.logisticsApiSetting"),
              link: "/settings/logistics-api-setting",
              controller: "Settings",
              action: "logisticsApiSetting",
            },
            {
              title: i18n.t("SettingNav.otherSetting"),
              link: "/settings/other-settings",
              controller: "Settings",
              action: "otherSetting",
            },
          ],
        },
        {
          title: i18n.t("SettingNav.printSetting"),
          icon: "fa-magic",
          link: "/settings/bussiness-settings",
          subitems: [
            {
              title: i18n.t("SettingNav.reportDesign"),
              link: "/settings/print-templates",
              controller: "PrintTemplates",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.cloudPrinterSetting"),
              link: "/settings/cloud-printer-setting",
              controller: "CloudPrints",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.cloudPrinterDesign"),
              link: "/settings/cloud-print-templates",
              controller: "CloudPrintTemplates",
              action: "index",
            },
          ],
        },
        {
          title: i18n.t("SettingNav.subAccountSettings"),
          icon: "fa-cogs",
          link: "/settings/sub-account-settings/sub-account-type",
          subitems: [
            {
              title: i18n.t("SettingNav.subAccountType"),
              link: "/settings/sub-account-settings/sub-account-type",
              controller: "SubAccountSettings",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.subAccount"),
              link: "/settings/sub-account-settings/sub-account",
              controller: "SubAccounts",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.subAccountSettingPort"),
              link: "/settings/sub-account-settings/sub-account-setting-port",
              controller: "SubAccountSettings",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.subAccountConfig"),
              link: "/settings/sub-account-settings/sub-account-configs",
              controller: "SubAccountConfigs",
              action: "index",
              show: function () {
                return this.settings && this.settings.push_platform == 2001;
              }.bind(this),
            },
          ],
        },
        {
          title: i18n.t("SettingNav.accountLogs"),
          icon: "fa-align-justify",
          link: "/settings/account-logs",
          subitems: [
            {
              title: i18n.t("SettingNav.manageAccountLogs"),
              link: "/settings/account-logs",
              controller: "AccountLogs",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.batchLogs"),
              link: "/settings/batch-logs",
              controller: "BatchLogs",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.taskLogs"),
              link: "/settings/task-logs",
              controller: "TaskLogs",
              action: "getJobLogs",
            },
            {
              title: i18n.t("SettingNav.taskBatchLogs"),
              link: "/settings/task-batch-logs",
              controller: "TaskLogs",
              action: "getBatchLogs",
            },
            {
              title: i18n.t("SettingNav.taskSyncErrLogs"),
              link: "/settings/task-sync-err-logs",
              controller: "TaskLogs",
              action: "getSyncErrLogs",
            },
            {
              title: i18n.t("SettingNav.queueDataLogs"),
              link: "/settings/queue-data-logs",
              controller: "AccountLogs",
              action: "index",
            },
          ],
        },
      ];
      return settingNavs;
    },
  },
};
</script>